import { render, staticRenderFns } from "./team-projects-editor.vue?vue&type=template&id=78518696&"
import script from "./team-projects-editor.vue?vue&type=script&lang=js&"
export * from "./team-projects-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports